<app-double-section-page-template [narrower]="true" [contentAlignment]="'center'">
  <ng-container intro-content>
    <h2 [type]="'h3'" double-section-page-template-title>{{ 'page-not-found.subheading' | translate }}</h2>
    <h3 [type]="'h2'" double-section-page-template-title>{{ 'page-not-found.heading' | translate }}</h3>
  </ng-container>
  <ng-container payload-content>
    <img src="/assets/icons/icon-warning.svg" double-section-page-template-icon />
    <p class="cm-paragraph">
      {{ 'page-not-found.text' | translate }}
    </p>
    <div class="cm-paragraph">
      <app-action-button label="page-not-found.button" [routerLink]="'/' | translate"></app-action-button>
    </div>
    <app-logged-link-pair
      appearance="no-label"
      routerLink="/support"
      href="/customer-support"
      addressLabel="{{ 'bankid-error.support' | translate }}"
      addressIcon="/assets/img/arrow-right-blue.svg"
    ></app-logged-link-pair>
  </ng-container>
</app-double-section-page-template>
